<template>
  <v-dialog
    v-model="show"
    max-width="700"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
  >
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-card :class="!mobile() ? '' : ''">
      <v-row
        :class="!mobile() ? 'pa-5' : 'pa-2'"
        no-gutters
      >
        <v-col
          :cols="!mobile() ? '12' : '12'"
          align="right"
          :class="!mobile() ? '' : 'pa-3'"
        >
          <v-icon
            ref="cancel"
            data-testid="cancel-button"
            min-width="100"
            class="rounded-xxl text-none"
            style="z-index:1;"
            @click="show=false"
          >
            mdi-close
          </v-icon>
        </v-col>
      </v-row>

      <v-row
        :no-gutters="!mobile()"
        :dense="mobile()"
        class="pb-4 rounded-xxl"
        :class="!mobile() ? 'pa-5' : ''"
      >
        <v-col
          :cols="!mobile() ? '4' : '12'"
          align="center"
          :class="!mobile() ? 'px-4' : 'pa-3'"
        >
          <v-avatar
            :size="!mobile() ? '165' : '125'"
            class="mx-2"
          >
            <img
              v-if="user.attributes.avatar_thumb == null"
              :src="defaultImage"
            >
            <img
              v-else
              :src="`${user.attributes.avatar_thumb}`"
            >
          </v-avatar>
        </v-col>

        <v-col
          :cols="!mobile() ? '8' : '12'"
          align="center"
          :class="!mobile() ? 'pl-6' : 'pa-3'"
        >
          <v-row
            :no-gutters="!mobile()"
            :dense="mobile()"
            class="rounded-xxl flex-column"
            :class="!mobile() ? 'mt-6' : ''"
          >
            <v-col
              class="pb-4"
              :cols="!mobile() ? '12' : '12'"
              align="left"
              :class="!mobile() ? '' : 'pa-3 text-center'"
            >
              <div class="text-h5 font-weight-bold darktext--text text-truncate" data-testid="profile-name">
                {{ user.attributes.first_name }} {{ user.attributes.last_name }}
              </div>
            </v-col>

            <v-col
              class="pb-4"
              :cols="!mobile() ? '12' : '12'"
              align="left"
              :class="!mobile() ? '' : 'pa-3 text-center'"
            >
              <div class="text-body-1 darktext--text" :max-lines="!mobile() ? '1' : '2'"  data-testid="profile-email">
                {{ $t('labelEmail') }}: {{ user.attributes.email }}
              </div>
            </v-col>

            <v-col
              class="pb-4"
              :cols="!mobile() ? '12' : '12'"
              align="left"
              :class="!mobile() ? '' : 'pa-3 text-center'"
            >
              <div
                v-if="this.viewedUser.attributes.email == this.spaceOwnerEmail"
                class="text-body-1 darktext--text"
                data-testid="profile-role"
              >
                {{ $t('spaceRole') }}: {{ $t('spaceOwner') }}
              </div>
              <div
                v-else-if="selectedRole == 'Space Admin'"
                class="text-body-1 darktext--text"
                data-testid="profile-role"
              >
                {{ $t('spaceRole') }}: {{ $t('spaceAdmin') }}
              </div>
              <div
                v-else-if="selectedRole == 'Booster'"
                class="text-body-1 darktext--text"
                data-testid="profile-role"
              >
                {{ $t('spaceRole') }}: {{ $t('userProfileRoleBooster') }}
              </div>
              <div
                v-else
                class="text-body-1 darktext--text"
                data-testid="profile-role"
              >
                {{ $t('spaceRole') }}: {{ $t('userProfileRoleMember') }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row
        :no-gutters="!mobile()"
        :dense="mobile()"
        class="mt-4"
        :class="!mobile() ? 'pl-5' : ''"
      >
        <v-col
          v-if="role == 'space_admin'"
          class="pb-4 px-6"
          :cols="!mobile() ? '4' : '8'"
          align="center"
        >
          <div class="filter-label text-left">
            <v-label for="filter-dropdown">{{ $t('filterByRole') }}</v-label>
          </div>
          <v-select
            id="filter-dropdown"
            v-model="selectedFilterRole"
            :items="filterRoles"
            outlined
            dense
            class="filter-dropdown mb-n6"
            append-icon="mdi-chevron-down"
            :menu-props="{ offsetY: true }"
            @change="updateFilter()"
            ref="roleFilter"
            data-testid="role-filter"
          ></v-select>
        </v-col>

        <v-col
          v-else
          class="pb-4"
          :cols="!mobile() ? '2' : '12'"
          align="center"
          :class="!mobile() ? 'px-4' : 'pa-3'"
        >
          <div
            class="text-body-1 darktext--text font-weight-bold"
          >
            {{ $t('access') }}:
          </div>
        </v-col>

        <v-col class="align-self-center clickable justify-end" data-testid="share-items-icon" :cols="!mobile() ? '6' : '2'" align="right">
          <v-icon
            size="24"
            @click="dialogVisibleShareItem = true" 
          >
            mdi-share-variant
          </v-icon>
        </v-col>
      </v-row>
      <v-row
        :no-gutters="!mobile()"
        :dense="mobile()"
        class=""
      >
        <v-col
          class="pb-4 "
          :cols="!mobile() ? '12' : '12'"
          align="center"
        >
          <v-tabs
            v-model="tabs"
            :color="'var(--v-accent-base)'"
            centered
            fixed-tabs
            :slider-color="'var(--v-accent-base)'"
            class="overflow-hidden"
          >
            <v-tab
              class="text-none"
              style="border-bottom: 2px solid var(--v-disabled-base);"
            >
              {{ $t('activitiesItem') }}
            </v-tab>

            <v-tab
              class="text-none"
              style="border-bottom: 2px solid var(--v-disabled-base);"
            >
              {{ $t('hubItem') }}
            </v-tab>
            
            <v-tab
              class="text-none"
              style="border-bottom: 2px solid var(--v-disabled-base);"
            >
              {{ $t('tagsLabel') }}
            </v-tab>

            <v-tabs-items 
              v-model="tabs"
            >
              <v-tab-item
                :transition="false"
                reverse-transition="false"
              >
                <v-card
                  flat
                >
                  <v-row ref="activities">
                    <v-col
                      v-if="loadingData"
                      cols="10"
                      class="mx-auto"
                    >
                      <v-progress-circular
                        size="72"
                        indeterminate
                        color="accent"
                        class="text-center justify-center ma-8 d-block mx-auto"
                      />
                    </v-col>
                    <v-col 
                      v-if="!loadingData"
                      cols="10"
                      class="mx-auto"
                      data-testid="list-mode" 
                    >
                      <v-row
                        v-if="!loadingData && activities.length == 0"
                        class="white"
                      >
                        <v-col cols="11" class="mx-auto px-0" data-testid="no-activity">
                          <div
                            class="
                              greytextlight--text
                              text-h6 text-md-h5
                              font-weight-bold
                              my-2
                              pa-4
                            "
                            align="center"
                          >
                            {{ $t("noActivitiesShared") }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row
                        v-else
                        v-for="item in activities"
                        :key="item.id"
                        align="center"
                        class="my-4 pa-0"
                      >
                        <v-col
                          cols="12"
                          class="pa-0"
                        >
                          <v-hover>
                            <v-card
                              slot-scope="{ hover }"
                              :height="!mobile() ? '65' : '57'"
                              rounded="xxl"
                              class="mx-auto rounded-xxl white"
                              :ripple="false"
                              :class="`elevation-${hover ? 10 : 6} ${
                                hover ? 'v-card--shadow' : 'v-card--flat'
                              }`"
                              :disabled="item.attributes.role !== 'booster'"
                              @click="item.attributes.role == 'booster' && proceedClick(item)"
                            >
                              <v-row 
                                :no-gutters="!mobile()"
                                :dense="mobile()">
                                <v-col
                                  :cols="!mobile() ? '2' : '3'"
                                  class="pa-0"
                                >
                                  <v-responsive>
                                    <v-img
                                      style="
                                        border: 1px solid var(--v-greylightBorder-base, 0.7);
                                      "
                                      class="rounded-xxl"
                                      :src="
                                        item.attributes.image
                                          ? item.attributes.image
                                          : require('../assets/cover-activity.jpg')
                                      "
                                      :height="!mobile() ? '66px' : '58px'"
                                    />
                                  </v-responsive>
                                </v-col>
                                <v-col
                                  :cols="!mobile() ? '3' : '3'"
                                  align-self="center" 
                                  class="pa-0"
                                  :class="!mobile() ? 'ml-7 mr-2' : 'ml-2'"
                                >
                                  <v-tooltip
                                    bottom
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-card-title
                                        class="text-left pa-0 no-break d-flex d-block"
                                        style="line-height:inherit"
                                        v-on="on"
                                      >
                                        <v-clamp
                                          autoresize
                                          :max-lines="1"
                                          class="text-body-1"
                                        >
                                          {{ item.attributes.title }}
                                        </v-clamp>
                                      </v-card-title>
                                    </template>
                                    <span>{{ item.attributes.title }}</span>
                                  </v-tooltip>
                                </v-col>
                                <v-col
                                  v-if="!mobile()"
                                  cols="3"
                                  align-self="center"
                                  align="left"
                                  class="
                                    text-center
                                    d-flex
                                    align-center
                                    justify-end
                                    pa-0
                                  "
                                >
                                  <v-card-text class="pa-0">
                                    <v-tooltip
                                      bottom
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-chip
                                          small
                                          data-testid="sharing-setting-chip"
                                          color="darktext"
                                          text-color="white"
                                          filter-icon="mdi-equalizer-outline"
                                          v-on="on"
                                        >
                                          <v-icon size="14" class="pr-1">
                                            mdi-share-variant
                                          </v-icon>
                                          <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                                          <span v-if="item.attributes.sharing_setting == 'Flexible'">{{ $t('sharingSettingFlexible') }}</span>
                                          <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                                        </v-chip>
                                      </template>
                                      <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedTooltip') }}</span>
                                      <span v-if="item.attributes.sharing_setting == 'Flexible'">{{ $t('sharingSettingFlexibleTooltip') }}</span>
                                      <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenTooltip') }}</span>
                                    </v-tooltip>
                                  </v-card-text>
                                </v-col>
                                <v-col
                                  :cols="!mobile() ? '3' : '5'"
                                  align-self="center"
                                  class="pa-0 d-flex justify-end"
                                  :class="mobile() ? 'pr-2' : ''"
                                >
                                  <v-tooltip
                                    bottom
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-card-title class="text-left pa-0 no-break" v-on="on">
                                        <v-clamp v-if="item.meta.user.data.attributes.role == 'Booster'" autoresize :max-lines="1" class="text-body-1">
                                          {{ $t('role') }}: {{ $t('userProfileRoleOwner') }}
                                        </v-clamp>
                                        <v-clamp v-if="item.meta.user.data.attributes.role == 'Participant' || item.meta.user.data.attributes.role == 'Guest'" autoresize :max-lines="1" class="text-body-1">
                                          {{ $t('role') }}: {{ $t('userProfileRoleMember') }}
                                        </v-clamp>
                                      </v-card-title>
                                    </template>
                                    <span v-if="item.meta.user.data.attributes.role == 'Booster'">{{ $t('role') }}: {{ $t('userProfileRoleOwner') }}</span>
                                    <span v-if="item.meta.user.data.attributes.role == 'Participant' || item.meta.user.data.attributes.role == 'Guest'">{{ $t('role') }}: {{ $t('userProfileRoleMember') }}</span>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-hover>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- Activities Pagination -->

                <v-row ref="pagination">
                  <v-col
                    cols="10"
                    class="mx-auto"
                  >
                    <Pagination
                      v-model="activityPageNumber"
                      class="mb-4"
                      circle
                      :data-length="activitiesInfo.total"
                      :page-number="activitiesInfo.currentPage"
                      total-visible="5"
                      :size="size"
                      @input="handleActivityPageChange"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
          
              <v-tab-item
                :transition="false"
                reverse-transition="false"
              >
              <v-card
                  flat
                >
                  <v-row ref="hubs">
                    <v-col
                      v-if="loadingData"
                      cols="10"
                      class="mx-auto"
                    >
                      <v-progress-circular
                        size="72"
                        indeterminate
                        color="accent"
                        class="text-center justify-center ma-8 d-block mx-auto"
                      />
                    </v-col>
                    <v-col 
                      v-if="!loadingData"
                      cols="10"
                      class="mx-auto"
                      data-testid="list-mode" 
                    >
                      <v-row
                        v-if="!loadingData && hubs.length == 0"
                        class="white"
                      >
                        <v-col cols="11" class="mx-auto px-0" data-testid="no-hubs">
                          <div
                            class="
                              greytextlight--text
                              text-h6 text-md-h5
                              font-weight-bold
                              my-2
                              pa-4
                            "
                            align="center"
                          >
                            {{ $t("noHubsShared") }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row
                        v-else
                        v-for="item in hubs"
                        :key="item.id"
                        align="center"
                        class="my-4 pa-0"
                      >
                        <v-col
                          cols="12"
                          class="pa-0"
                        >
                          <v-hover>
                            <v-card
                              slot-scope="{ hover }"
                              :height="!mobile() ? '65' : '57'"
                              rounded="xxl"
                              class="mx-auto rounded-xxl white"
                              :ripple="false"
                              :class="`elevation-${hover ? 10 : 6} ${
                                hover ? 'v-card--shadow' : 'v-card--flat'
                              }`"
                              :disabled="item.attributes.role !== 'booster'"
                              @click="item.attributes.role == 'booster' && proceedClick(item)"
                            >
                              <v-row 
                                :no-gutters="!mobile()"
                                :dense="mobile()">
                                <v-col
                                  :cols="!mobile() ? '2' : '3'"
                                  class="pa-0"
                                >
                                  <v-responsive>
                                    <v-img
                                      style="
                                        border: 1px solid var(--v-greylightBorder-base, 0.7);
                                      "
                                      class="rounded-xxl"
                                      :src="
                                        item.attributes.image
                                          ? item.attributes.image
                                          : require('../assets/background-hub.jpg')
                                      "
                                      :height="!mobile() ? '66px' : '58px'"
                                    />
                                  </v-responsive>
                                </v-col>
                                <v-col
                                  :cols="!mobile() ? '3' : '3'"
                                  align-self="center" 
                                  class="pa-0"
                                  :class="!mobile() ? 'ml-7 mr-2' : 'ml-2'"
                                >
                                  <v-tooltip
                                    bottom
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-card-title
                                        class="text-left pa-0 no-break d-flex d-block"
                                        style="line-height:inherit"
                                        v-on="on"
                                      >
                                        <v-clamp
                                          autoresize
                                          :max-lines="1"
                                          class="text-body-1"
                                        >
                                          {{ item.attributes.title }}
                                        </v-clamp>
                                      </v-card-title>
                                    </template>
                                    <span>{{ item.attributes.title }}</span>
                                  </v-tooltip>
                                </v-col>
                                <v-col
                                  v-if="!mobile()"
                                  cols="3"
                                  align-self="center"
                                  align="left"
                                  class="
                                    text-center
                                    d-flex
                                    align-center
                                    justify-end
                                    pa-0
                                  "
                                >
                                  <v-card-text class="pa-0">
                                    <v-tooltip
                                      bottom
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-chip
                                          small
                                          data-testid="sharing-setting-chip"
                                          color="darktext"
                                          text-color="white"
                                          filter-icon="mdi-equalizer-outline"
                                          v-on="on"
                                        >
                                          <v-icon size="14" class="pr-1">
                                            mdi-share-variant
                                          </v-icon>
                                          <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                                          <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                                        </v-chip>
                                      </template>
                                      <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedHubTooltip') }}</span>
                                      <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenHubTooltip') }}</span>
                                    </v-tooltip>
                                  </v-card-text>
                                </v-col>
                                <v-col
                                  :cols="!mobile() ? '3' : '5'"
                                  align-self="center"
                                  class="pa-0 d-flex justify-end"
                                  :class="mobile() ? 'pr-2' : ''"
                                >
                                  <v-tooltip
                                    bottom
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-card-title class="text-left pa-0 no-break" v-on="on">
                                        <v-clamp v-if="item.meta.user.data.attributes.role == 'Booster'" autoresize :max-lines="1" class="text-body-1">
                                          {{ $t('role') }}: {{ $t('userProfileRoleOwner') }}
                                        </v-clamp>
                                        <v-clamp v-if="item.meta.user.data.attributes.role == 'Participant' || item.meta.user.data.attributes.role == 'Guest'" autoresize :max-lines="1" class="text-body-1">
                                          {{ $t('role') }}: {{ $t('userProfileRoleMember') }}
                                        </v-clamp>
                                      </v-card-title>
                                    </template>
                                    <span v-if="item.meta.user.data.attributes.role == 'Booster'">{{ $t('role') }}: {{ $t('userProfileRoleOwner') }}</span>
                                    <span v-if="item.meta.user.data.attributes.role == 'Participant'">{{ $t('role') }}: {{ $t('userProfileRoleMember') }}</span>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-hover>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- Hubs Pagination -->

                <v-row ref="pagination">
                  <v-col
                    cols="10"
                    class="mx-auto"
                  >
                    <Pagination
                      v-model="hubPageNumber"
                      class="mb-4"
                      circle
                      :data-length="hubsInfo.total"
                      :page-number="hubsInfo.currentPage"
                      total-visible="5"
                      :size="size"
                      @input="handleHubPageChange"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item
                :transition="false"
                reverse-transition="false"
              >
              <v-card
                  flat
                >
                  <v-row ref="tags">
                    <v-col
                      v-if="loadingData"
                      cols="10"
                      class="mx-auto"
                    >
                      <v-progress-circular
                        size="72"
                        indeterminate
                        color="accent"
                        class="text-center justify-center ma-8 d-block mx-auto"
                      />
                    </v-col>
                    <v-col 
                      v-if="!loadingData"
                      cols="10"
                      class="mx-auto"
                      data-testid="list-mode" 
                    >
                      <v-row
                        v-if="!loadingData && tags.length == 0"
                        class="white"
                      >
                        <v-col cols="11" class="mx-auto px-0" data-testid="no-hubs">
                          <div
                            class="
                              greytextlight--text
                              text-h6 text-md-h5
                              font-weight-bold
                              my-2
                              pa-4
                            "
                            align="center"
                          >
                            {{ $t("noTagsShared") }}
                          </div>
                        </v-col>
                      </v-row>
                     

                      <v-row
                        v-else
                        v-for="item in tags"
                        :key="item.id"
                        align="center"
                        class="my-4 pa-0"
                      >
                        <v-col
                          cols="12"
                          class="pa-0"
                        >
                          <v-hover>
                            <v-card
                              slot-scope="{ hover }"
                              :height="!mobile() ? '65' : '57'"
                              rounded="xxl"
                              class="mx-auto rounded-xxl white"
                              :ripple="false"
                              :class="`elevation-${hover ? 10 : 6} ${
                                hover ? 'v-card--shadow' : 'v-card--flat'
                              }`"
                              :disabled="item.attributes.role !== 'booster'"
                              @click="item.attributes.role == 'booster' && proceedClick(item)"
                            >
                              <v-row 
                                :no-gutters="!mobile()"
                                :dense="mobile()"
                                :style="!mobile() ? 'height:65px' : 'height:57px'">
                                <v-col
                                  cols="!mobile() ? '12' : '12'"
                                  align-self="center" 
                                  class="pa-0"
                                  :class="!mobile() ? 'ml-7 mr-2' : 'ml-2'"
                                >
                                  <v-tooltip
                                    bottom
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-card-title
                                        class="text-left pa-0 no-break d-flex d-block"
                                        style="line-height:inherit"
                                        v-on="on"
                                      >
                                        <v-clamp
                                          autoresize
                                          :max-lines="1"
                                          class="text-body-1"
                                        >
                                          {{ item.attributes.name }}
                                        </v-clamp>
                                      </v-card-title>
                                    </template>
                                    <span>{{ item.attributes.name }}</span>
                                  </v-tooltip>
                                </v-col>
                               
                              </v-row>
                            </v-card>
                          </v-hover>
                        </v-col>
                      </v-row>





                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>
      </v-row>
    </v-card>

    <SearchItemToShareDialog
      v-if="dialogVisibleShareItem"
      :visible="dialogVisibleShareItem"
      :selected-role="selectedRole"
      :viewed-user="viewedUser"
      data-testid="search-dialog-share-items"
      @close="dialogVisibleShareItem = false"
      @proceedSubmit="submitShareItem($event)"
    />

  </v-dialog>
</template>
<script>
import i18n from '../plugins/i18n';
import VClamp from "vue-clamp";
import AlertMessages  from '../components/AlertMessages'
import { getSpaceUsersStatistics } from "../api/spaceApi";
import { getUserActivityAccess, getUserActivityAccessWithRoleFilter, shareItemWithUser, getUserTags } from "../api/activityApi";
import { getUserHubAccess, getUserHubAccessWithRoleFilter } from "../api/hubApi";
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin';
import Pagination from "../components/Pagination";
import SearchItemToShareDialog from './SearchItemToShareDialog.vue';

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: ''
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t('submit')
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t('cancel')
    },
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedRole:{
      type: String,
      default:'participant'
    },
    page: {
      type: String,
      default: ''
    },
    viewedUser: {
      type: Object,
      default() {
          return {}
      }
    },
  },
  components: {
    VClamp,
    AlertMessages,
    Pagination,
    SearchItemToShareDialog,
  },
  mixins: [repeatedMethodsMixin],
  data(){
      return{
        disabled:false,
        valid: true,
        alertMsg: '',
        alertType:'',
        alertValue:'',
        check: false,
        spaceId: window.$cookies.get("space_id"),
        role: localStorage.space ? JSON.parse(localStorage.space).role : '',
        setRole: this.selectedRole,
        boosters: 0,
        boosters_allowed: 0,
        spaceAdmins: 0,
        spaceMembers: 0,
        statistics: {},
        leftBoosters: 0,
        leftSpaceMembers: 0,
        statisticsBoosters: 0,
        statisticsSpaceMembers: 0,
        loadingData:false,
        defaultImage: require('../assets/user_images/profile-avatar.png'),
        user: this.viewedUser,
        tabs: 'activities',
        activityPageNumber: 1,
        hubPageNumber: 1,
        size: 12,
        activities: [],
        activitiesInfo: {
          currentPage: 1,
          total: 0
        },
        hubs: [],
        hubsInfo: {
          currentPage: 1,
          total: 0
        },
        selectedFilterRole: 'All',
        filterRoles: [{ value: 'All', text: i18n.t("all")}, 'Owner', 'Member'],
        spaceOwnerEmail: localStorage.space
        ? JSON.parse(localStorage.space).owner_email
        : false,
        dialogVisibleShareItem: false,
        tags: [],
      }
    },    
    computed: {
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
        productPlan() {
          return this.$store.state.productPlan;
        },
    },
    async created() {
      this.loadingData = true;
      if(this.setRole == null){
        // eslint-disable-next-line
        this.setRole = 'participant'
      }
      await this.getSubscriptionStatistics();
      await this.fetchUserActivityAccess(this.selectedFilterRole);
      await this.fetchUserHubAccess(this.selectedFilterRole);
      await this.fetchUserTags();
      this.loadingData = false;
    },
    methods: {
      proceedSubmit() {
        this.$router.push({path: '/space/subscription'})
      },
      submitDialogBtn(setRole) {
        this.valid = this.$refs.form.validate()
        if(this.valid){
          this.$emit('proceedSubmit',setRole)
        }
      },
      async submitShareItem(items) {
        try {
          var itemsAttribute = [];
          items.forEach(item => {
            itemsAttribute.push({
              entity_type: item.type,
              id: item.id
            });
          });
          let data = {
              data: {
                  type: "share-entity",
                  attributes: {
                      items: itemsAttribute,
                  },
                  relationships: {
                      user: {
                          data: {
                              type: 'users',
                              id: this.viewedUser.id
                          }
                      },
                  }
              }
          }

          const response = await shareItemWithUser(this.spaceId, data);
          if (response.status == 200) {
            await this.fetchUserActivityAccess(this.selectedFilterRole);
            await this.fetchUserHubAccess(this.selectedFilterRole);
            await this.fetchUserTags();
            
            this.dialogVisibleShareItem = false
            this.alertType = "success";
            this.alertValue = true;
            this.alertMsg = i18n.t("itemsSharedSuccessfully");
          }
        } catch (e) {
          if (e.response) {
            this.alertType = "error";
            this.alertValue = true;
            this.alertMsg = i18n.t("serverError");
          }
        }
        this.loadingData = false;
      },
      async getSubscriptionStatistics() {
        this.loadingData =true
        try {
          const response = await getSpaceUsersStatistics(this.spaceId);
          if (response.status == 200) {
            this.statistics = response.data.meta;
            this.statisticsBoosters = this.statistics.booster_count + this.statistics.booster_invites + this.statistics.admin_invites;
            this.statisticsSpaceMembers = this.statistics.total_members_count + this.statistics.total_invites;
            this.boosters_allowed = this.statistics.boosters_allowed;
            this.spaceMembers = this.statistics.space_members_allowed;
            this.leftBoosters = this.statistics.boosters_allowed - this.statisticsBoosters;
            this.leftSpaceMembers = this.statistics.total_allowed - this.statisticsSpaceMembers;
          }
        } catch (e) {
          if (e.response) {
            this.alertType = "error";
            this.alertValue = true;
            this.alertMsg = i18n.t("serverError");
          }
        }
        this.loadingData = false;
      },
      async fetchUserActivityAccess(filteredRole){
        this.loadingData = true;
        let response;
        try {
          if (filteredRole == 'All'){
            response = await getUserActivityAccess(this.spaceId, this.activityPageNumber, this.size, this.user.id)
          } else {
            let role = filteredRole == 'Owner' ? '2' : '3'
            response = await getUserActivityAccessWithRoleFilter(this.spaceId, this.activityPageNumber, this.size, this.user.id, role)
          }
            if(response.status){
              if(response.status == 200) {
                this.activities = response.data.data;
                this.activitiesInfo = response.data.meta.page;
                window.scrollTo(0,0);
              }
            }
        } catch (e) {
          if(e.response){
            if(e.response.status == 404) {
              this.$router.push({name: 'PageNotFound'});
            }
            else if(e.response.status == 403){
              this.$router.push({name: 'PageAccessDenied'});
            } else {
              this.alertValue = true;
              this.alertType = 'error';
              this.alertMsg =  i18n.t('serverError');
            }
          }
        }
        this.loadingData = false;
      },
      async fetchUserHubAccess(filteredRole) {
        this.loadingData = true;
        let response;
        try {
          if (filteredRole == 'All') {
            response = await getUserHubAccess(this.spaceId, this.hubPageNumber, this.size, this.user.id)
          } else {
            let role = filteredRole == 'Owner' ? '2' : '3'
            response = await getUserHubAccessWithRoleFilter(this.spaceId, this.hubPageNumber, this.size, this.user.id, role)
          }
            if(response.status){
              if(response.status == 200) {
                this.hubs = response.data.data;
                this.hubsInfo = response.data.meta.page;
                window.scrollTo(0,0);
              }
            }
        } catch (e) {
          if(e.response){
            if(e.response.status == 404) {
              this.$router.push({name: 'PageNotFound'});
            }
            else if(e.response.status == 403){
              this.$router.push({name: 'PageAccessDenied'});
            } else {
              this.alertValue = true;
              this.alertType = 'error';
              this.alertMsg =  i18n.t('serverError');
            }
          }
        }
        this.loadingData = false;
      },

      async fetchUserTags() {
        this.loadingData = true;
        let response;
        try {
          response = await getUserTags(this.spaceId, this.user.id)
            if(response.status){
              if(response.status == 200) {
                this.tags = response.data.data;
                window.scrollTo(0,0);
              }
            }
        } catch (e) {
          if(e.response){
            this.alertValue = true;
            this.alertType = 'error';
            this.alertMsg =  i18n.t('serverError');
          }
        }
        this.loadingData = false;
      },
      proceedClick(item) {
        if (item.type == "activities") {
          this.$router.push({ path: "/activity/" + item.id });
        } else {
          this.$router.push({ path: "/hub/" + item.id });
        }
      },
      handleActivityPageChange(value) {
        this.activitiesInfo.currentPage = value;
        this.activityPageNumber = value;
        this.fetchUserActivityAccess(this.selectedFilterRole);
      },
      handleHubPageChange(value) {
        this.hubsInfo.currentPage = value;
        this.hubPageNumber = value;
        this.fetchUserHubAccess(this.selectedFilterRole);
      },
      async updateFilter() {
        this.loadingData = true;
          await this.fetchUserActivityAccess(this.selectedFilterRole);
          await this.fetchUserHubAccess(this.selectedFilterRole);
          await this.fetchUserTags();
        this.loadingData = false;
      }
    },
  }
</script>
<style scoped>
.filter-label .v-label  {
  font-size: 14px;
}
.filter-dropdown {
  border-radius: 10px;
}
.filter-dropdown .v-menu__content .theme--light .v-menu__content--fixed .menuable__content__active {
  margin-top: 43px;
}
</style>